import type { FC } from 'react';

import type { CustomOverlayProps } from 'ag-grid-react';

import { GenericButton } from '@shared/components/ui/custom/buttons/GenericButton';

export interface GridOverlayParams {
  isError?: boolean;
  errorMessage?: string;
  refetch?: () => void;
  noRowsMessage?: string;
}

export const GridOverlay: FC<CustomOverlayProps<unknown, GridOverlayParams>> = (props) => {
  const {
    isError = false,
    errorMessage = 'Error fetching data',
    refetch,
    noRowsMessage = 'No rows to display',
  } = props.context || {};

  const message = isError ? errorMessage : noRowsMessage;
  const showRetryButton = isError && typeof refetch === 'function';

  return (
    <div
      className="absolute top-[130px] left-1/2 -translate-x-1/2 flex flex-col items-center pointer-events-auto w-full"
      data-testid="grid-state-container"
    >
      <div className="flex flex-col items-center gap-3 text-center">
        <h2 className="text-2xl font-light text-foreground" data-testid="grid-state-title">
          {message}
        </h2>

        {showRetryButton && (
          <GenericButton
            onClick={refetch}
            variant="link"
            className="text-sm text-primary hover:text-primary/80 cursor-pointer bg-transparent border-none p-0"
            data-testid="grid-state-retry-button"
          >
            Retry
          </GenericButton>
        )}
      </div>
    </div>
  );
};
